import _get from "utils/get";
import { utmBannerParams } from "../constants/mixpanel";

export function getMainCard(cards) {
    let lastCard;
    let lastActiveCard;

    cards.forEach(card => {
        lastCard = lastCard && lastCard.creationDate > card.creationDate ? lastCard : card;
        if (card.externalStatusCode === "NORMAL") {
            lastActiveCard = lastActiveCard && lastActiveCard.creationDate > card.creationDate ? lastActiveCard : card;
        }
    });

    return lastActiveCard || lastCard
}

export function getSunbitCard4LastDigits(card) {
    return _get(card, ['last4Digits'], "XXXX");
}

export function getIsUpdateAtpBannerNeeded(props){
  const atpDetails = getAtpDetails(props);

  return atpDetails ? atpDetails.isAtpUpdateNeeded : false;

}

export function getCardCustomerId(props) {
  return _get(props, ['card','card','customerId'], null);
}

export function getBalance(props) {
    return _get(props, ["card", "balance"], null);
}

export function getAtpDetails(props) {
  return _get(props, ["card", "card", "atpDetails"], false);
}
export function getAccount(props) {
    return _get(props, ["card", "card"], null);
}

export function getStatement(props) {
    return _get(props, ["card", "statement"], null);
}

export function getLastStatement(statements) {
    return statements[Object.keys(statements)[0]];
}

export function getAtpBannerUTMQueryParams(){
   return Object.keys(utmBannerParams).map(key => key + '=' + utmBannerParams[key]).join('&');

}



// WEBPACK FOOTER //
// ./src/card/cardHelper.js